"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Sidebar_1 = require("@Components/Sidebars/Sidebar");
const react_1 = __importStar(require("react"));
const Button_1 = require("@Components/Buttons/Button");
const payment_status_definitions_1 = __importDefault(require("@App/const/payment-status-definitions"));
require("./index.scss");
const dayjs_1 = __importDefault(require("dayjs"));
const RoyaltiesSidebar = (props) => {
    const { closeSidebar, data } = props;
    if (!data) {
        return;
    }
    const mapStatus = (status, updateTime) => (Object.assign({ time: updateTime ? (0, dayjs_1.default)(updateTime).format('hh:mma') : null, status }, payment_status_definitions_1.default[status.toLocaleLowerCase()]));
    const processStatusHistory = (0, react_1.useCallback)(() => {
        let tempDay = '';
        let indexCount = -1;
        const updates = data.statusUpdates
            .slice()
            .sort((a, b) => (new Date(a.updateTime) < new Date(b.updateTime) ? 1 : -1))
            .reduce((result, item) => {
            let status = item.updateStatus ? item.updateStatus : 'Submitted';
            if (status === 'PendingPayerFunds') {
                status = 'Pending Funds';
            }
            else if (status === 'FraudReview') {
                status = 'Under Review';
            }
            if (tempDay !== (0, dayjs_1.default)(item.updateTime).format('dddd, MMMM DD, YYYY')) {
                tempDay = (0, dayjs_1.default)(item.updateTime).format('dddd, MMMM DD, YYYY');
                indexCount++;
                result.push({
                    [tempDay]: [mapStatus(status, item.updateTime)],
                });
            }
            else {
                result[indexCount][tempDay].push(mapStatus(status, item.updateTime));
            }
            return result;
        }, []);
        if (data.status === 'Transferred') {
            // Transferred status has no date/time associated with it so we push it to the bottom of the status updates list
            const keys = Object.keys(updates[updates.length - 1]);
            updates[updates.length - 1][keys[0]].push(mapStatus(data.status));
        }
        return updates;
    }, [data]);
    return (react_1.default.createElement(Sidebar_1.Sidebar, { onClose: closeSidebar },
        react_1.default.createElement("div", { className: "status-sidebar" },
            react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: 'status-head' },
                    react_1.default.createElement("h2", null, "Payment Status"),
                    react_1.default.createElement("p", { className: 'large grey-text' }, "Payment status will be reflected here as it is updated.")),
                processStatusHistory().map((day, index) => (react_1.default.createElement(react_1.default.Fragment, { key: index },
                    react_1.default.createElement("p", { className: 'small bold date' }, Object.keys(day)[0]),
                    Object.values(day)[0].map((update, nestedIndex) => (react_1.default.createElement("div", { className: 'status-block', key: nestedIndex },
                        react_1.default.createElement("div", { className: 'status-circle-block' },
                            react_1.default.createElement("div", { className: `status-circle ${update.color}` })),
                        react_1.default.createElement("div", { className: 'status-info' },
                            react_1.default.createElement("div", { className: 'status-row' },
                                update.time && react_1.default.createElement("p", { className: 'small bold time' }, update.time),
                                react_1.default.createElement("p", { className: 'small' }, update.status)),
                            react_1.default.createElement("p", { className: 'small description grey-text' }, update.explanation),
                            update.link.includes('methods') && (react_1.default.createElement("p", { className: 'small description grey-text' },
                                "For more information on payment methods, click",
                                ' ',
                                react_1.default.createElement("a", { className: 'small description', href: `https://help.themlc.com/en/support/what-are-the-options-for-payment-methods`, target: "_blank", rel: "noreferrer" }, "here"))),
                            update.link.includes('contactus') && (react_1.default.createElement("p", { className: 'small description grey-text' },
                                ' ',
                                "For assistance, please contact The MLC Support Team",
                                ' ',
                                react_1.default.createElement("a", { className: 'small description', href: `https://portal.themlc.com/contact-us`, target: "_blank", rel: "noreferrer" }, "here."))),
                            update.link.includes('statements') && (react_1.default.createElement("div", { className: 'small description grey-text' },
                                "You can also click",
                                react_1.default.createElement("a", { className: 'small description', href: `https://help.themlc.com/en/support/how-can-i-access-my-statement-in-the-portal`, target: "_blank", rel: "noreferrer" },
                                    ' ',
                                    "here",
                                    ' '),
                                "for steps to download statements."))))))))),
                react_1.default.createElement("div", { className: 'close-button' },
                    react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'primary', onClick: closeSidebar }, "Close"))))));
};
exports.default = RoyaltiesSidebar;
